import * as types from "../actions/ActionTypes";

const initialState = {
  // Store lists and dropdowns in objects keyed by type
  lists: {},
  dropdowns: {},

  // State for a single record being viewed/edited
  record: null,

  // UI and flow control state
  loading: false,
  redirectToList: false,
  validation_error: null,
  showUpdateForm: false,
  showViewPage: false,
};

const ConfigurationReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.CONFIGURATIONS_REQUEST:
      return {
        ...state,
        loading: true,
        redirectToList: false,
        validation_error: null,
      };

    case types.CONFIGURATIONS_SUCCESS: {
      const { type, data } = action.payload;
      return {
        ...state,
        loading: false,
        lists: {
          ...state.lists,
          [type]: data, // e.g., lists: { language: [...] }
        },
      };
    }

    case types.CONFIGURATIONS_DROPDOWN_SUCCESS: {
      const { type, data } = action.payload;
      return {
        ...state,
        dropdowns: {
          ...state.dropdowns,
          [type]: data, // e.g., dropdowns: { language: [...] }
        },
      };
    }

    case types.CONFIGURATIONS_GET_SUCCESS: {
      const { record, actionType } = action.payload;
      return {
        ...state,
        loading: false,
        record: record,
        showUpdateForm: actionType === "update",
        showViewPage: actionType === "view",
      };
    }

    case types.CONFIGURATIONS_VALIDATION_ERROR:
      return {
        ...state,
        loading: false,
        validation_error: action.validation_error,
      };

    case types.CONFIGURATIONS_REDIRECT:
      return {
        ...state,
        loading: false,
        redirectToList: true,
        showUpdateForm: false,
        showViewPage: false,
        record: null,
        validation_error: null,
      };

    case types.HIDE_CONFIGURATIONS_FEILD_VALIDATION_ERROR:
      if (state.validation_error && state.validation_error[action.field_key]) {
        const new_validation_error = { ...state.validation_error };
        delete new_validation_error[action.field_key];
        return { ...state, validation_error: new_validation_error };
      }
      return state;

    default:
      return state;
  }
};

export default ConfigurationReducer;
